import loadable from '@loadable/component';

export const ManageEventsPageLoadable = loadable(
  () => import('./ManageEventsPage'),
  {
    resolveComponent: (module) => module.ManageEventsPage,
    ssr: false,
  },
);
